import React from 'react';
import { Icon } from './Icon.js';
export const IconHeart2 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M3.61091 4.61091C1.46303 6.7588 1.46303 10.2412 3.61091 12.3891L12 21L20.3891 12.3891C22.537 10.2412 22.537 6.7588 20.3891 4.61091C18.2412 2.46303 14.7588 2.46303 12.6109 4.61091C12.3831 4.83871 12.1795 5.08152 12 5.33615C11.8205 5.08152 11.6169 4.83871 11.3891 4.61091C9.2412 2.46303 5.7588 2.46303 3.61091 4.61091Z", stroke: "currentColor", strokeWidth: "2", fill: "none" })));
};
//# sourceMappingURL=IconHeart2.js.map